
import { Component, Vue } from 'vue-property-decorator';
import DepartmentRepository from '@/services/Departments';
import { WPXFormValue } from '@/components/templates/WPXForm';
import CreateDepartmentForm from '@/services/Departments/forms/CreateDepartmentForm';
import PageHeader from '@/components/layout/PageHeader.vue';

@Component({
  inject: [
    'departmentRepository',
  ],
  components: {
    PageHeader,
  },
})
export default class CreateDepartment extends Vue {
  private readonly departmentRepository!: DepartmentRepository;

  private loading: boolean = true;

  private form: WPXFormValue<CreateDepartmentForm> = new WPXFormValue(CreateDepartmentForm);

  private created(): void {
    this.loading = false;
  }

  private async createDepartment(): Promise<void> {
    try {
      await this.departmentRepository.createDepartment({
        name: this.form.data.name,
      })

      this.$successDialog.show(`Successfully created department '${this.form.data.name}'`);
    } catch (e) {
      this.$errorDialog.show(e.response.data.message);
    }
  }
}
